import { gql } from '@apollo/client';

export const DELETE_USER_ASSIGNED_ACTIVITY = gql`
  mutation DeleteUserAssignedActivity($id: ID!) {
    userActivity: deleteUserAssignedActivity(id: $id) {
      id
    }
  }
`;
